VariationsWidget = window.VariationsWidget ?= {}
Cart = window.Cart ?= {}

Cart.Helpers = require '../../cart/common/helpers'

class VariationsWidget.Controller
  constructor: ->
    @ie7 = true if OptimizeSuite?.TrackingHub.user.browser is 'IE' and OptimizeSuite.TrackingHub.user.browserVersion is '7.0'
    @i18n = I18n.scoped() if I18n?
    @updateSelectElements "", true
    @availableOptions = @getAvailableOptions()
    @cheapestOption = @getCheapestAvailableOption @availableOptions
    @clearTraitsOnCarouselSelection = VariationsWidget.clearTraitsOnCarouselSelection
    @$selectElements = $('#variation-traits').find('.variation-trait')
    if VariationsWidget.preSelectTraits?.length
      @makeSelectionsViaPreselection()
    else
      @updateSelectionsToDefault()

  render: (latestSelection, updateCarousel = true) ->
    if latestSelection.selection?
      @updateSelections latestSelection
      @updateSelectElements latestSelection.trait
      @availableOptions = @getAvailableOptions()
      @cheapestOption = @getCheapestAvailableOption @availableOptions
      @updatePricing @cheapestOption, @availableOptions.length
      if updateCarousel then @updateCarousel()
      @removeErrorMessages()
    return

  updateSelectionsToDefault: ->
    for selectElement in @$selectElements or []
      $(selectElement).find('option:eq(0)').prop('selected', true)

  updateSelections: (latestSelection) ->
    for collection in VariationsWidget.collections
      if collection.models[0].get('traitName') == latestSelection.trait
        collection.setSelected latestSelection.id
        break
    return

  updateSelectElements: (latestSelection, updateAll = false) ->
    if VariationsWidget.printOptionPrice then updateAll = true
    for collection in VariationsWidget.collections
      traitName = collection.models[0].get('traitName')

      # Don't update the most recent select that was just chosen, unless boolean specifies otherwise
      if traitName != latestSelection || updateAll
        conditions = @getConditions(collection.selected())
        lastSelection = (_.keys(conditions).length == VariationsWidget.collections.length - 1)

        enabledOptions = []
        unavailableOptions = []
        if not $.isEmptyObject conditions
          enabledOptions = _.where VariationsWidget.options, conditions
        else
          enabledOptions = VariationsWidget.options

        enabledValues = _.pluck enabledOptions, traitName

        unavailableValues = _.uniq enabledValues
        availableValues = []
        for option in enabledOptions
          for value in unavailableValues
            if (value == option[traitName]) and @isOptionAvailable(option)
              availableValues.push value

        unavailableValues = _.difference unavailableValues, availableValues
        enabledValues.unshift "#{@i18n.t('js.modules.variations.selector')} #{traitName}"

        for trait in VariationsWidget.collections
          if trait.models[0].get('traitName') == traitName
            for model in trait.models
              @setOptionState( model, enabledValues, unavailableValues )

              #if all other collections have selections
              if lastSelection and !conditions[traitName]?
                @setOptionPrice( model, enabledValues, enabledOptions )
              else if !conditions[traitName]?
                @setOptionFromPrice( model, enabledValues, enabledOptions )
              else
                model.set('optionPrice', false)

    if @ie7
      $('option').removeClass "ie7-color"
      $('option[disabled]').addClass "ie7-color"

  setOptionState: (model, enabledValues, unavailableValues) ->
    printSoldOut = VariationsWidget.printSoldOut

    if model.id is 0 or (_.contains enabledValues, model.get('traitValue'))
      if model.get('isSoldOut') or model.get('isUnavailable') or (unavailableValues? and (_.contains unavailableValues, model.get('traitValue')))
        model.set('disabled', true)
      else
        model.set('disabled', false)
      model.set('forceDisplay', printSoldOut is true)
    else
      model.set('disabled', true)
      # for unrelated options, force display only when printSoldOut is true and it is getaways pageType
      forceDisplay = printSoldOut is true and not VariationsWidget.isGetaways
      model.set('forceDisplay', forceDisplay)
    return

  setOptionFromPrice: (model, enabledValues, enabledOptions) ->
    printOptionPrice = VariationsWidget.printOptionPrice
    return unless printOptionPrice

    value = model.get('traitValue')
    name = model.get('traitName')
    selected = model.get('selected')
    modelID = model.get('id')
    traitOptions = _.filter( enabledOptions, ((item) -> item[name] is value) )

    if selected or modelID == 0
      return model.set('optionPrice', false)

    if (_.contains enabledValues, value)
      cheapestOption = @getCheapestAvailableOption(traitOptions)
      if cheapestOption?
        model.set('optionPrice', I18n.t('js.modules.variations.from_price', {minPrice: cheapestOption.newPrice}))
    return

  setOptionPrice: (model, enabledValues, enabledOptions) ->
    printOptionPrice = VariationsWidget.printOptionPrice
    return unless printOptionPrice

    value = model.get('traitValue')
    name = model.get('traitName')
    selected = model.get('selected')
    modelID = model.get('id')

    if selected or modelID == 0
      return model.set('optionPrice', false)

    if (_.contains enabledValues, value)
      for option in enabledOptions
        if value == option[name]
          model.set('optionPrice', option.newPrice)
    return

  getConditions: (selected) ->
    conditions = {}
    for tempCollection in VariationsWidget.collections
      tempSelected = tempCollection.selected()
      tempSelectedTraitValue = tempSelected.get('traitValue')
      if tempSelectedTraitValue != selected.get('traitValue') and not @isSelectionDefault tempSelectedTraitValue
        conditions[tempSelected.get('traitName')] = tempSelectedTraitValue
    conditions

  getAvailableOptions: ->
    properties = {}
    for collection in VariationsWidget.collections
      selectedTrait = collection.selected()
      selectedTraitValue = selectedTrait.get('traitValue')
      properties[selectedTrait.get('traitName')] = selectedTraitValue unless @isSelectionDefault selectedTraitValue
    if $.isEmptyObject properties
      options = VariationsWidget.options
    else
      options = _.where VariationsWidget.options, properties
    options

  getCheapestAvailableOption: (availableOptions) ->
    currentCheapest = undefined

    for option in availableOptions
      if @isOptionAvailable(option) and (currentCheapest is undefined or (option.amount < currentCheapest.amount))
        currentCheapest = option

    return currentCheapest or availableOptions[0]

  overridePriceDataWithSaleInfo: (priceData, option) ->
    return unless option?.regularPrice?

    sale = {}
    if option.regularPrice
      # urgency pricing
      _.extend sale,
          urgencyPricing:
            regularPrice: option.regularPrice
            newPrice: option.newPrice
            pricingMetadata: option.pricingMetadata

    _.extend priceData, {sale} if sale isnt {}

  updatePricing: (cheapestOption, length) ->
    priceData =
      dealUuid: VariationsWidget.uuid
      id: cheapestOption.id
      value: cheapestOption.oldPrice
      percent: cheapestOption.discount
      savings: cheapestOption.savePrice
      price: cheapestOption.newPrice
      lengthClass: cheapestOption.lengthClass
      buyUrl: @buyButtonUrl cheapestOption
      uuid: cheapestOption.uuid
      variationsSelected: length is 1 and not @areAnySelectionsDefault VariationsWidget.collections
      hideOriginalPriceAndDiscount: cheapestOption.hideOriginalPriceAndDiscount
      showDifferenceMessage: cheapestOption.showDifferenceMessage
      soldMessage: cheapestOption.soldMessage
      shippingValue: cheapestOption.shippingValue
      valueSourceMetadata: cheapestOption.valueSourceMetadata

    if cheapestOption.affirmAmount?
      _.extend priceData,
          affirmAmount: cheapestOption.affirmAmount

    @overridePriceDataWithSaleInfo(priceData, cheapestOption)
    window.VariationsWidget.currentOptionInfo = priceData

    window.DealEventPipe.trigger "priceUpdate", priceData
    window.DealEventPipe.trigger "goodsWarrantyUpdate", priceData if payload.goodsWarranty

  buyButtonUrl: (cheapestOption) ->
    return cheapestOption.externalUrl if cheapestOption.externalUrl?.length

    if payload?.cartStatus and not payload.shouldDisableGoodsCart
      Cart.Helpers.generateCartUrl(cheapestOption.uuid, VariationsWidget.uuid)
    else
      cheapestOption.url

  updateCarousel: ->
    data = {}
    selectedIndices = @findSelectedCollections VariationsWidget.collections
    for index in selectedIndices
      selectedTrait = VariationsWidget.collections[index].selected()
      data[selectedTrait.get('traitName')] = selectedTrait.get('traitValue')
    window.DealEventPipe.trigger 'traitsUpdate', {selectedTraits: data}

  selectTraitsFromPotentialValues: (traitsHash) ->
    return unless @clearTraitsOnCarouselSelection
    selections = []
    for traitName, traitValues of traitsHash
      if traitValues.length == 1 then selections.push
        trait: traitName
        selection: traitValues[0]

    return if selections.length < 1
    @clearSelections()
    @makeSelections(selections)

  makeSelectionsViaPreselection: ->
    option = _.findWhere VariationsWidget.options, uuid: VariationsWidget.dealOptionUuid
    return unless option? and @isOptionAvailable(option)
    selections = []
    for trait in VariationsWidget.preSelectTraits or []
      for collection in VariationsWidget.collections or []
        if collection.models[0].get("traitName") is trait
          selections.push
            trait: trait
            selection: option[trait]
          break
    @makeSelections selections
    @updateCarousel()

  clearSelections: ->
    for collection in VariationsWidget.collections or []
      selectedTrait = collection.selected()
      selectedTraitName = selectedTrait.get('traitName')
      if not @isSelectionDefault selectedTrait.get('traitValue')
        selection = @i18n.t('js.modules.variations.select', name: selectedTraitName)
        data =
          trait: selectedTraitName
          selection: selection
          id: 0
        $("#trait-#{selectedTrait.get('traitIndex')}").val(selection)
        unless $("#trait-#{selectedTrait.get('traitIndex')}").val()?
          $("#trait-#{selectedTrait.get('traitIndex')}").prop('selectedIndex', 0)
        @render data, false

  makeSelections: (selections) ->
    for element in selections or []
      for collection in VariationsWidget.collections or []
        if collection.models[0].get('traitName') == element.trait
          trait = collection.findWhere
            traitValue: element.selection
          if !trait.get('disabled')
            element['id'] = trait.get('id')
            $('#trait-'+collection.models[0].get('traitIndex')).val(element.selection)
            @render element, false
            break
    return

  showErrorMessages: ->
    VariationsWidget.error.show()
    VariationsWidget.error.$el.addClass "icon-circle-alert"
    defaultCollections = @findDefaultCollections VariationsWidget.collections
    for index in defaultCollections
      $('#trait-'+index).addClass 'error'

  removeErrorMessages: ->
    VariationsWidget.error.hide() unless @areAnySelectionsDefault VariationsWidget.collections
    selectedCollections = @findSelectedCollections VariationsWidget.collections
    for index in selectedCollections
      $('#trait-'+index).removeClass 'error'

  areAnySelectionsDefault: (collections) ->
    _.some collections, (collection) =>
      RegExp("(^#{@i18n.t('js.modules.variations.selector')}|#{@i18n.t('js.modules.variations.selector')}$)",'i').test(collection.selected().get('traitValue'))

  isSelectionDefault: (selection) =>
    RegExp("(^#{@i18n.t('js.modules.variations.selector')}|#{@i18n.t('js.modules.variations.selector')}$)",'i').test(selection)

  findDefaultCollections: (collections) =>
    defaultCollections = []
    for collection, index in collections
      if RegExp("(^#{@i18n.t('js.modules.variations.selector')}|#{@i18n.t('js.modules.variations.selector')}$)",'i').test(collection.selected().get('traitValue')) then defaultCollections.push index
    defaultCollections

  findSelectedCollections: (collections) =>
    selectedCollections = []
    for collection, index in collections
      if not RegExp("(^#{@i18n.t('js.modules.variations.selector')}|#{@i18n.t('js.modules.variations.selector')}$)",'i').test(collection.selected().get('traitValue')) then selectedCollections.push index
    selectedCollections

  isOptionAvailable: (option) ->
    return false unless option?
    not (option.isSoldOut or option.isUnavailable)

module.exports = VariationsWidget.Controller



// WEBPACK FOOTER //
// ./modules/variations/frontend/variations-widget-controller.coffee